<template>
  <delete-button @click="removeCondition"></delete-button>
</template>

<script>
import chatBubbleModule from '@/store/modules/chat-bubble.module'
import DeleteButton from '../DeleteButton'
import templateModule from '@/store/modules/template.module'
import answerController from '@/controllers/answer.controller'
import templateController from '@/controllers/template.controller'
import stateTreeUtils from '@/utils/state-tree.utils'

export default {
  name: 'DeleteConditionButton',

  components: {
    DeleteButton
  },

  props: {
    botId: {
      type: String,
      required: true
    }
  },

  computed: {
    bubbleSelected: chatBubbleModule.bubbleSelected,
    stateTree: chatBubbleModule.stateTree,

    previewController() {
      return templateModule.isTemplateEditor() ? templateController : answerController
    }
  },

  methods: {
    removeCondition() {
      const node = stateTreeUtils.findNode(this.stateTree, this.bubbleSelected)
      this.previewController.removeConditionSection(node, templateModule.getTemplateId())
    }
  }
}
</script>
